import { TimerSandEmptyIcon } from './TimerSandEmptyIcon';

/**
 * author: Google
 * id DD31FFF2-A93B-41F5-BA6C-1732E8A8DEFF
 * name timer-sand-empty
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand-empty.svg
 * tags
 * - Date / Time 
 */
export const HourglassEmptyIcon = TimerSandEmptyIcon;
export default HourglassEmptyIcon